import "owl.carousel";
import { getImageUrl } from "../helpers/mediaUrl";

export default class productListing {
  constructor() {
    this.init();
  }

  buildCustomProductCard = (product) => {
    const baseURL = globalThis.baseURL || "/";
    const img = getImageUrl(product.Image_URL);
    const productLink = product.product_URL
      ? `${baseURL}customer/productSummary/${product.product_URL}`
      : "#";

    const categoryLabel = product.Category_Name || "Service";
    let description = product.Description || product.Product_Description || "";
    // Strip HTML tags and truncate to 55 chars for a single line display
    description = description.replace(/<\/?[^>]+(>|$)/g, "");
    if (description.length > 55) {
      description = description.substring(0, 55).trim() + "...";
    }

    return `
      <div class="col-12 vendor-summary-product-item mb-3">
        <div class="vendor-summary-product-card w-100 d-flex bg-white rounded-2 overflow-hidden border shadow-sm">
          <!-- Product Image -->
          <div class="vendor-summary-product-img-wrap flex-shrink-0">
            <a href="${productLink}" class="d-block h-100 w-100" ${
              productLink === "#" ? 'onclick="return false;"' : ""
            }>
              <img src="${img}" alt="${product.Product_Service_Name}" class="vendor-summary-product-img w-100 h-100" loading="lazy" onerror="this.src='${baseURL}assets/default.png';this.style.objectFit='contain';" />
            </a>
          </div>

          <!-- Product Info -->
          <div class="vendor-summary-product-info flex-grow-1 p-3 d-flex flex-column justify-content-between">
            <div>
              <div class="d-flex align-items-start justify-content-between mb-2">
                <h6 class="vendor-summary-product-name text-truncate mb-0 pr-2 fw-600" style="min-width: 0;">${product.Product_Service_Name}</h6>
                <span class="vendor-summary-category-label flex-shrink-0 ms-2">${categoryLabel}</span>
              </div>
              <p class="vendor-summary-product-vendor text-muted small mb-1">${product.Business_Name || product.Vendor_Name || ""}</p>
              <p class="vendor-summary-product-description text-muted small mb-0">${description}</p>
            </div>

            <!-- Price -->
            <div class="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
              <span class="vendor-summary-product-price fw-bold" style="color: #ff385c; font-size: 1.1rem;">₹${product.Price}</span>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  init = () => {
    // Screen size handling
    const screenWidth = $(window).width();
    if (screenWidth < 768) {
      $(".displayDuringMobViews").removeClass("d-none");
    } else {
      $(".displayDuringDesktopViews").removeClass("d-none");
    }

    // Identifiers and Globals
    this.Vendor_ID =
      $(".VendorSummaryPage").data("vendor-id") ||
      window.location.pathname.split("/").filter(Boolean).pop();

    // Set consistent globals if missing
    globalThis.X_API_KEY =
      globalThis.X_API_KEY ||
      window.CONFIG?.X_API_KEY ||
      "eb48e580-b26a-4993-9c84-966952758f1f";

    if (!globalThis.baseURL) {
      const inputBaseURL = $(".baseURL").val();
      if (inputBaseURL) {
        globalThis.baseURL = inputBaseURL.endsWith("/")
          ? inputBaseURL
          : inputBaseURL + "/";
      } else {
        // Harder fallback: try to guess from pathname if we are in /locaso/app/
        const pathParts = window.location.pathname.split("/");
        const appIndex = pathParts.indexOf("app");
        if (appIndex !== -1) {
          globalThis.baseURL =
            window.location.origin +
            pathParts.slice(0, appIndex + 1).join("/") +
            "/";
        } else {
          globalThis.baseURL = window.location.origin + "/";
        }
      }
    }

    console.log("Vendor Summary: Initialized", {
      Vendor_ID: this.Vendor_ID,
      baseURL: globalThis.baseURL,
      X_API_KEY: globalThis.X_API_KEY,
    });

    this.writtenPart = $(".writtenPart");
    this.grid = $(".ProductListingPage");

    this.bindEvents();

    // Delay fetch slightly to ensure all globals and DOM elements are ready
    setTimeout(() => {
      this.getVendorDetailsWithMultipleCategories();
    }, 100);
  };

  // Stub to prevent errors from legacy calls in other components
  getVendorImages = () => {
    console.log("Vendor Summary: getVendorImages called (legacy stub)");
  };

  bindEvents = () => {
    const w = $(window).width();
    if (w < 710) {
      this.writtenPart.removeClass("col");
    } else {
      this.writtenPart.addClass("col");
    }

    $(window).on("load", () => {
      this.calOwlCarousel();
    });
  };

  calOwlCarousel = () => {
    $(".carousel_se_07_carousel").owlCarousel({
      nav: false,
      dots: false,
      mouseDrag: true,
      responsiveClass: true,
      responsive: {
        0: { items: 3 },
        480: { items: 3 },
        767: { items: 5 },
        992: { items: 6 },
        1200: { items: 8 },
      },
    });
  };

  showVendorDetails = (res) => {
    if (!res || (!res.vendor && !res.Vendor)) {
      console.warn("Vendor Summary: No vendor data found");
      $(".vendorBusinessName").html("Vendor Not Found");
      return;
    }

    const vendorInfo = res.vendor || res.Vendor || {};
    const products = Array.isArray(res.products || res.Products)
      ? res.products || res.Products
      : [];
    const vendorCategoriesData = Array.isArray(res.categories || res.Categories)
      ? res.categories || res.Categories
      : [];
    const vendorImages = Array.isArray(res.vendorImages || res.VendorImages)
      ? res.vendorImages || res.VendorImages
      : [];
    const deliveryList = Array.isArray(res.delivery || res.Delivery)
      ? res.delivery || res.Delivery
      : [];

    // Header Updates
    console.log("Vendor Summary: Rendering Header with Info:", vendorInfo);
    $(".vendorBusinessName").html(vendorInfo.Business_Name || "No Name");
    $(".vendorDescription").html(vendorInfo.Description || "");
    $(".vendorShortAddress").html(
      `${vendorInfo.Address?.Address_Line_1 || ""}, ${vendorInfo.Address?.City || ""}`,
    );
    $(".vendorMinOrder").html(vendorInfo.Minimum_Order || "0");
    $(".vendorMainImage").attr("src", getImageUrl(vendorInfo.Image_URL));

    // Images Carousel
    this.renderImageCarousel(vendorInfo.Image_URL, vendorImages);

    // Categories and Products
    this.renderCategoriesAndProducts(vendorCategoriesData, products);

    // Delivery check
    if (deliveryList.length === 0) {
      $(".deliveryOptionBtn").hide();
    } else {
      $(".vendorDeliveryOptions").html(
        deliveryList[0].Picklist_display_value || "Delivery Available",
      );
    }

    // Refresh Cart interactions
    if (globalThis.CartObject) {
      globalThis.CartObject.notifyCartUpdate();
    }
  };

  renderImageCarousel = (mainImg, additionalImages) => {
    $(".vendorImageCarousel").empty();
    const images = [];
    if (mainImg) images.push(mainImg);
    additionalImages.forEach((img) => {
      if (img.Image_url && img.Image_url !== mainImg)
        images.push(img.Image_url);
    });

    images.forEach((imgUrl, index) => {
      const active = index === 0 ? "active" : "";
      $(".vendorImageCarousel").append(`
        <div class="carousel-item ${active}">
          <img src="${getImageUrl(imgUrl)}" class="d-block w-100 rounded-3" style="height: 300px; object-fit: cover;" />
        </div>
      `);
    });
  };

  renderCategoriesAndProducts = (categories, products) => {
    const categoryContainer = $(".owl-carousel.vendor-categories-item");
    const productsContainer = $(".all-vendor-category-products");

    categoryContainer.trigger("destroy.owl.carousel").empty();
    productsContainer.empty();

    if (categories.length <= 1) {
      $(".categories-product-listing").hide();
    }

    categories.forEach((category, i) => {
      const status = i === 0 ? "active" : "";
      const firstActiveItem = i === 0 ? "currentActiveCategory" : "";
      const selectedItem = i === 0 ? "selected-item" : "";

      const categoryItem = `
        <div class="item">
          <div class="col-md-12 d-flex justify-content-center">
            <div id="${category.Picklist_ID}" class="vendorCategoriesButtons ${selectedItem} text-center zoom ${status} ${firstActiveItem}">
              <div class="category-icon-wrap mb-2">
                <img src="${getImageUrl(category.Icon_Url)}" 
                     alt="${category.Picklist_display_value}" 
                     class="img-fluid" 
                     onerror="this.src='${globalThis.baseURL}assets/default.png'">
              </div>
              <p class="small fw-bold mb-0">${category.Picklist_display_value}</p>
            </div>
          </div>
        </div>`;

      categoryContainer.append(categoryItem);

      // Products for this category
      const catProducts = products.filter(
        (p) =>
          p.Picklist_ID == category.Picklist_ID ||
          p.Picklist_parent_ID == category.Picklist_ID,
      );

      const recommended = catProducts.filter((p) => p.Recommended_flag == 1);
      const others = catProducts; // Showing all in menu for now, or filter if needed

      const recommendedHtml =
        recommended.length > 0
          ? `
        <div class="product-section-mb mb-4">
            <h5 class="category-title-modern mb-3">Best Sellers</h5>
            <div class="row">
                ${recommended.map((p) => this.buildCustomProductCard(p)).join("")}
            </div>
        </div>`
          : "";

      const allProductsHtml =
        others.length > 0
          ? `
        <div class="product-section-mb">
            <h5 class="category-title-modern mb-3">Menu</h5>
            <div class="row">
                ${others.map((p) => this.buildCustomProductCard(p)).join("")}
            </div>
        </div>`
          : "";

      productsContainer.append(`
        <div class="vendor-category-products ${category.Picklist_ID} ${i > 0 ? "d-none" : ""}">
            ${recommendedHtml}
            ${allProductsHtml}
        </div>
      `);
    });

    this.calOwlCarousel();
    $(".vendorCategoriesButtons").on("click", this.showVendorCategoriesDetails);
  };

  showVendorCategoriesDetails = (event) => {
    const prevCategoryID = $(".currentActiveCategory").attr("id");
    const newCategoryID = $(event.currentTarget).attr("id");

    $(
      `span.vendor-category-products.${prevCategoryID}, .vendor-category-products.${prevCategoryID}`,
    ).addClass("d-none");
    $(
      `span.vendor-category-products.${newCategoryID}, .vendor-category-products.${newCategoryID}`,
    ).removeClass("d-none");

    $(`#${prevCategoryID}`).removeClass(
      "currentActiveCategory active selected-item",
    );
    $(`#${newCategoryID}`).addClass(
      "currentActiveCategory active selected-item",
    );
  };

  getVendorDetailsWithMultipleCategories = async () => {
    const apiUrl =
      globalThis.baseURL +
      "api/customer/ProductSummary/getVendorDetailsWithMultipleCategoriesForVendor";
    console.log("Vendor Summary: Fetching data from", apiUrl);
    $.ajax({
      url: apiUrl,
      type: "POST",
      data: { Vendor_ID: this.Vendor_ID },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        console.log("Vendor Summary: Data received", result);
        this.showVendorDetails(result);
        if (result && result.categories) {
          this.renderCategoriesAndProducts(
            result.categories,
            result.products || [],
          );
        }
      },
      error: (err) => {
        console.error("Vendor Summary: API Error", err);
      },
    });
  };
}
